export * from './anniversary-background.component';
